<template>
  <!-- 出入金明细列表 -->
  <div class="opage">
    <div>
      <!-- 出入金明细 -->
      <baseBreadcrumb :page="$t('message.moneyManagement')" :menu="$t('message.entryAndExitDetails')"></baseBreadcrumb>
      <!-- 搜索 -->
      <div class="body">
        <!-- 明细 -->
        <p class="theDetail">
          {{ $t('message.pendingDepositAmountConfirmation') }}： <span> {{ unconfirmed.total }}</span> 円
          <el-popover placement="bottom" trigger="click">
            <el-table :data="unconfirmed.list" border size="small">
              <el-table-column width="60" property="rowNumber" label="NO" align="center"></el-table-column>
              <el-table-column width="150" property="bill_type_name" label="入金报告类型" align="center"></el-table-column>
              <el-table-column width="300" label="订单号/配送单号" align="center">
                <template slot-scope="scope">
                  <!-- 配送单详情链接 -->
                  <router-link v-if="scope.row.order_sn.substr(0, 1) == 'P'" class="redFont"
                    :to="'/porderDetail?porder_sn=' + scope.row.order_sn" target="_blank">
                    {{ scope.row.order_sn }}
                  </router-link>
                  <!-- 订单详情链接 -->
                  <router-link v-else class="redFont" :to="'/orderPaymentDetail?order_sn=' + scope.row.order_sn"
                    target="_blank">
                    {{ scope.row.order_sn }}
                  </router-link>
                </template>
              </el-table-column>
              <el-table-column width="150" property="created_at" label="入金报告提交时间" align="center"></el-table-column>
              <el-table-column width="150" property="pay_realname" label="入金名义" align="center"></el-table-column>
              <el-table-column width="150" property="amount" label="提交入金金额 - 円" align="center"></el-table-column>
              <el-table-column width="150" property="bill_method_name" label="银行" align="center"></el-table-column>
            </el-table>
            <el-button type="primary" size="mini" slot="reference">
              {{ $t('message.theDetail') }}</el-button>
          </el-popover>
        </p>
        <div class="search">
          <div class="row">
            <!-- 订单号.派送单号 -->
            <div class="item">
              <el-input v-model="datas.order_sn" placeholder="订单号.派送单号" clearable onfocus="this.select()">
              </el-input>
            </div>
            <!-- 开始日期-->
            <div class="item">
              <el-date-picker v-model="datas.dateStart" :placeholder="$t('message.startDate')" class="Container"
                type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 240px">
              </el-date-picker>
            </div>
            <!--  结束日期-->
            <div class="item">
              <el-date-picker v-model="datas.dateEnd" :placeholder="$t('message.dateClosed')" class="Container"
                default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 240px">
              </el-date-picker>
            </div>
            <!-- 账单类型 -->
            <div class="item">
              <el-select v-model='datas.bill_type' :placeholder="$t('message.billingType')">
                <el-option v-for='item in billType' :key='item.key' :label='item.value' :value='item.key'>
                </el-option>
              </el-select>
            </div>
            <!-- 交易方式 -->
            <div class="item">
              <el-select v-model='datas.bill_method' :placeholder="$t('message.transactionWay')">
                <el-option v-for='item in billMethod' :key='item.key' :label='item.value' :value='item.key'>
                </el-option>
              </el-select>
            </div>
            <!-- 搜索 -->
            <el-button type="primary" @click="search">
              {{ $t("message.search") }}
            </el-button>
            <!-- 重置 -->
            <el-button @click="reset">
              {{ $t("message.reset") }}
            </el-button>
          </div>
          <div class="operation">
            <!-- 导出EXCEL -->
            <span type="primary" @click="handleExportExcel" class="btns">{{ $t('message.exportExcel') }}</span>
          </div>
        </div>
        <div class="table">
          <ol>
            <li class="flex05">NO</li>
            <!-- 确认入账时间 -->
            <li>{{ $t('message.confirmTheCreditingTime') }}</li>
            <!-- 提出时间 -->
            <li>{{ $t('message.forwardTime') }}</li>
            <!-- 客户名 -->
            <li>{{ $t('message.customerName') }}</li>
            <!-- 注文書・配送書 -->
            <li class="flex2">{{ $t('message.noteDocumentsdeliveryBooks') }}</li>
            <!-- 内容 -->
            <li class="flex3">{{ $t('message.content') }}</li>
            <!-- 名义 -->
            <li>{{ $t('message.mingYi') }}</li>
            <!-- 账单类型 -->
            <li>{{ $t('message.billingType') }}</li>
            <!-- 交易方式 -->
            <li>{{ $t('message.transactionWay') }}</li>
            <!-- 出入金金额 -->
            <li>出金額</li>
            <li>入金額</li>
            <!-- 残金 -->
            <li>{{ $t('message.residualGold') }}</li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <li class="flex05">{{ index + 1 }}</li>
            <!-- 确认入账时间 -->
            <li>
              <div style="width: 80px;text-align: center;">{{ item.confirm_at }}</div>
            </li>
            <!-- 提出时间 -->
            <li>
              <div style="width: 80px;text-align: center;">{{ item.created_at }}</div>
            </li>
            <!-- 客户名 -->
            <li>{{ item.user ? item.user.realname : '' }}</li>
            <!-- 注文書・配送書 -->
            <li class="flex2">
              <div v-if="item.order_sn">
                <!-- 2023/2/22 大榭说配送单号和订单号都用这个参数 -->
                <p>
                  <!-- 配送单详情链接 -->
                  {{ item.order_sn.substr(0, 1) == 'P' ? '配送書' : '注文書' }} <router-link
                    v-if="item.order_sn.substr(0, 1) == 'P'" class="redFont"
                    :to="'/porderDetail?porder_sn=' + item.order_sn" target="_blank">
                    {{ item.order_sn }}
                  </router-link>
                  <!-- 订单详情链接 -->
                  <router-link v-else class="redFont" :to="'/orderPaymentDetail?order_sn=' + item.order_sn"
                    target="_blank">
                    {{ item.order_sn }}
                  </router-link>
                </p>
              </div>
            </li>
            <!-- 内容 -->
            <li class="flex3">
              <div v-if="item.adjust_detail != false && item.adjust_detail != null" class="showDetail">
                <div style=" overflow: hidden;">
                  <p v-for="(item, index) in item.adjust_detail[0]" :key="index" :title="item">
                    {{ item }}
                  </p>
                </div>
              </div>
            </li>
            <!-- 名义 -->
            <li>{{ item.client_bill_reason }}</li>
            <!-- 账单类型 -->
            <li>{{ item.bill_type_name }}</li>
            <!-- 交易方式 -->
            <li>{{ item.bill_method_name }}</li>
            <!-- 2023/2/22 原型图上出入金分开显示,接口是一起显示,按接口来 -->
            <!-- 出入金金额 -->
            <li>{{ item.amount <= 0 ? item.amount : '' }}</li>
            <li>{{ item.amount >= 0 ? item.amount : '' }}</li>
            <!-- 残金 -->
            <li>{{ item.balance }}</li>

          </ul>
          <div v-if="tableData == false" class="No_data">暂无数据</div>
        </div>
        <!-- 分页 -->
        <div class="paginationContainer">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="datas.page" :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

      datas: {
        user_id: this.$route.query.userID,
      },
      tableData: [],
      total: 0,
      checked: false,
      billType: [],
      billMethod: [],
      unconfirmed: {},//确认中金额
    };
  },
  component: {},
  created() {
    this.billList();
    this.billTypeMap();
    this.billMethodMap();
    this.billUnconfirmed()
  },
  methods: {
    // 客户-确认中金额
    billUnconfirmed() {
      this.$api.clienteleApi.billUnconfirmed(this.datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.data.msg);
        this.unconfirmed = res.data
      })
    },
    // excel导出
    handleExportExcel() {
      let datasNew = JSON.parse(JSON.stringify(this.datas))
      datasNew.pageSize = 99999999
      this.$api.clienteleApi.billList(datasNew).then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0) return this.$message.error(res.data.msg);
        let excelData = res.data.data
        require.ensure([], () => {
          const { export_json_to_excel } = require("@/utlis/Export2Excel");
          const tHeader = [
            // 确认入账时间
            this.$t('message.confirmTheCreditingTime'),
            // 提出时间
            this.$t('message.forwardTime'),
            // 注文書・配送書
            this.$t('message.noteDocumentsdeliveryBooks'),
            // 内容
            this.$t('message.content'),
            // 账单类型
            this.$t('message.billingType'),
            // 交易方式
            this.$t('message.transactionWay'),
            // 出入金金额
            this.$t('message.adjust'),
            // 残金
            this.$t('message.residualGold'),
          ];
          const filterVal = [
            'confirm_at',
            'created_at',
            'order_sn',
            'adjust_detail',
            'bill_type_name',
            'bill_method_name',
            'amount',
            'balance'
          ];
          const list = excelData; //把data里的tableData存到list
          const data = this.formatJson(filterVal, list);
          export_json_to_excel(tHeader, data, "出入金明细");
        });
        this.total = res.data.total;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // 可选交易方式
    billMethodMap() {
      this.$api.clienteleApi.billMethodMap(this.datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.data.msg);
        this.billMethod = res.data
      })
    },
    // 获取可选账单类型列表
    billTypeMap() {
      this.$api.clienteleApi.billTypeMap(this.datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.data.msg);
        this.billType = res.data
      })
    },
    // 重置
    reset() {
      this.datas = {
        user_id: this.$route.query.userID,

      };
      this.billList();
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.billList();
    },
    // 获取配送单列表
    billList() {
      this.$api.clienteleApi.billList(this.datas).then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0) return this.$message.error(res.data.msg);
        this.tableData = res.data.data;


        this.total = res.data.total;

      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.billList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.billList();
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  margin: 24px 0;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .row {
    display: flex;
    margin-bottom: 16px;

    .item {
      width: 240px;
      margin-right: 24px;
    }
  }

  .operation {
    display: flex;
    justify-content: center;
    align-items: center;

    * {
      margin-bottom: 26px;
    }
  }
}

.No_data {
  margin: 20px auto;
  text-align: center;
  font-size: 20px;
}

.flex05 {
  flex: 0.5;
}

.flex15 {
  flex: 1.5;
}

.flex2 {
  flex: 2;

}

.readOnly {
  pointer-events: none;
}

.blurFont {
  color: blue;
}

.redFont {
  color: red;
}

.table {
  font-size: 14px;

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 9;
    display: flex;
    height: 40px;
    background: #edeff4;
    border-radius: 4px 4px 0 0;
    justify-content: center;
    align-items: center;

    li {
      height: 40px;
      text-align: center;
      align-items: center !important;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;


    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  ul {
    li {
      word-break: break-all;
    }
  }

  .flex05 {
    flex: 0.5;
  }

  .flex1 {
    flex: 1;
  }

  .flex2 {
    flex: 2;
  }

  .flex3 {
    flex: 3;
    overflow: hidden;
  }

  .flex15 {
    flex: 1.5;
  }

  .important {
    background-color: #e0e7f7;
    max-height: 100px;
    overflow: hidden;
  }

  ul {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #edeff4;
    transition: all 0.3s;


    &:hover {
      background-color: #fff;
    }

    /deep/ .el-input__inner {
      padding: 0;
      text-align: center;
    }
  }
}

.showDetail {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  p {
    max-width: 86%;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
  }
}

.btns {
  color: red;
  text-decoration: underline;
  background-color: transparent;
  margin: 0;
  padding: 0;
  cursor: pointer;
}

.theDetail {
  font-size: 20px;

  span {
    font-weight: bold;
    color: #B4272D;
  }
}
</style>
